<template>
	<div class="container account_wallet">
		<div class="content">
			<div class="card">
				<h4 class="title mb_20">{{ $t('account-wallet.title1') }}</h4>
				<div class="mb_20">
					<AccountPicker @changeAccount="getAccountInfo"></AccountPicker>
				</div>

				<!--        account assets-->
				<div v-if="isSelectedAccount" class="bg_black_box">
					<div class="d_flex justify_between">
						<div class="d_flex align_items_center">
							<div :class="'coin_icon type_01 mb_0 ' + assetInfo.code"></div>
							<p class="coin_name fs_18">
								{{ assetInfo.code }}<br />
								<span>{{ assetInfo.title }}</span>
							</p>
						</div>

						<div class="balance_area align_items_end">
							<div class="quantity mr_5">{{ accountInfo.balance }}</div>
							<span class="currency">{{ assetInfo.code }}</span>
						</div>
					</div>

					<template v-if="assetInfo.code === 'JPYS'">
						<div class="button_area justify_between">
							<button class="button_blue">
								{{ $t('account-wallet.btn_charge') }}
							</button>
							<div>
								<button class="button_white mr_5" @click="withdrawModal = true">
									{{ $t('account-wallet.btn_jpys_send') }}
								</button>
								<button class="button_bg_red">
									{{ $t('account-wallet.btn_receive') }}
								</button>
							</div>
						</div>
					</template>

					<template v-else>
						<div class="button_area">
							<button class="button_white mr_5">
								{{ $t('account-wallet.btn_other_send') }}
							</button>
							<button class="button_bg_red">
								{{ $t('account-wallet.btn_receive') }}
							</button>
						</div>
					</template>
				</div>
				<!--        account assets-->
				<span class="divide_line"></span>

				<template v-if="assetInfo.code === 'JPYS'">
					<p style="text-align: center; margin-top: 126px">
						{{ $t('account-wallet.text1') }}
					</p>
				</template>

				<template v-else>
					<div class="qr_area">
						<p>{{ $t('account-wallet.my_wallet') }}</p>
						<div class="qr_image_wrap">
							<img src="@/assets/images/qr_sample.jpg" alt="" />
						</div>
						<p class="address">1M7XYLV8VujqJ4qDGXpuVp33LuVhbEJsUN</p>
						<button class="button_copy">
							{{ $t('account-wallet.btn_copy') }}
						</button>
					</div>
				</template>
			</div>
		</div>
	</div>
	<ModalView v-if="withdrawModal" @closeModal="withdrawModal = false">
		<h4 class="title">{{ $t('account-wallet.modal.title1') }}</h4>
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text1') }}<br />
				{{ $t('account-wallet.modal.text2') }}<br />
				{{ $t('account-wallet.modal.text3') }}
			</p>
		</div>
		<h4 class="title">{{ $t('account-wallet.modal.title2') }}</h4>
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text4') }}
			</p>
		</div>
		<p class="caution">
			{{ $t('account-wallet.modal.caution') }}
		</p>
		<div class="button_area">
			<button class="fc_black" @click="withdrawModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="withdrawModal2 = true">
				{{ $t('button.next') }}
			</button>
		</div>
	</ModalView>
	<ModalView v-if="withdrawModal2" @closeModal="withdrawModal2 = false">
		<div class="text_box">
			<p>
				{{ $t('account-wallet.modal.text5') }}<br />
				{{ $t('account-wallet.modal.text6') }}<br />
				{{ $t('account-wallet.modal.text7') }} <br />
				{{ $t('account-wallet.modal.text8') }}<br />
				{{ $t('account-wallet.modal.text9') }}<br />
				{{ $t('account-wallet.modal.text10') }}
			</p>
		</div>
		<div class="box_check">
			<label class="checkbox_container">
				{{ $t('account-wallet.modal.check1') }}
				<input type="checkbox" />
				<span class="checkmark"></span>
			</label>
		</div>
		<div class="button_area">
			<button class="fc_black" @click="withdrawModal2 = false">
				{{ $t('button.back') }}
			</button>
			<button class="fc_red">{{ $t('button.request') }}</button>
		</div>
	</ModalView>
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import AccountPicker from '@/components/AccountPicker';
import { fetchAccount } from '@/api/account';
import { commonError } from '@/common/dialog';
import { Navigation } from 'swiper';
import { mapGetters } from 'vuex';
export default {
	name: 'Wallet',
	components: {
		ModalView,
		AccountPicker,
	},
	data() {
		return {
			myWallet: 'JPYS',
			selected: false,
			selectedAsset: '',
			withdrawModal: false,
			withdrawModal2: false,
			isSelectedAccount: false,
			assetInfo: {},
			accountInfo: {},
		};
	},
	setup() {
		const onSwiper = swiper => {
			console.log(swiper);
		};
		const onSlideChange = () => {
			console.log('slide change');
		};
		return {
			onSwiper,
			onSlideChange,
			modules: [Navigation],
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		...mapGetters('lang', ['lang']),

		own_assets_items() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(asset_item => {
				if (group.includes(asset_item.seq)) data.push(asset_item);
			});
			return data;
		},
	},
	methods: {
		checkAsset(e) {
			let selected = e.target.value;
			console.log('selected : ', selected);
		},
		async getAccountInfo(account_seq) {
			const params = {
				account_seq_or_number: account_seq,
			};
			const { account_info } = await fetchAccount(params).catch(commonError);
			this.assetInfo = this.assets.find(item => {
				return item.seq === account_info.asset_seq;
			});
			this.accountInfo = account_info;
			this.isSelectedAccount = true;
		},
		toHome() {
			this.$router.push({ name: 'auth-dashboard' });
		},
	},
	created() {
		if (this.$route.query.account_seq) {
			this.getAccountInfo(this.$route.query.account_seq);
			this.isSelectedAccount = true;
		}
	},
};
</script>
